/* PDP ギャラリーの横スクロール判定と即時移動を共有する */
(() => {
  const namespace = window.AuremeProductGallery || {};

  if (namespace.ScrollUtils) {
    return;
  }

  const SCROLL_TOLERANCE = 1;

  const ScrollUtils = {
    SCROLL_TOLERANCE,

    isReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },

    isNearScrollLeft(scrollContainer, targetLeft, tolerance = SCROLL_TOLERANCE) {
      if (!scrollContainer) return false;
      return Math.abs(scrollContainer.scrollLeft - targetLeft) < tolerance;
    },

    isStableScrollLeft(currentLeft, previousLeft, tolerance = SCROLL_TOLERANCE) {
      return previousLeft !== null && Math.abs(currentLeft - previousLeft) < tolerance;
    },

    getSettledScrollLeftFrameCount({
      currentLeft,
      previousLeft,
      stableFrames = 0,
      targetLeft = undefined,
      tolerance = SCROLL_TOLERANCE,
    }) {
      const isStable = this.isStableScrollLeft(currentLeft, previousLeft, tolerance);
      const numericTargetLeft = Number(targetLeft);
      const shouldCheckTarget = Number.isFinite(numericTargetLeft);
      const isAtTarget =
        !shouldCheckTarget || Math.abs(currentLeft - numericTargetLeft) <= tolerance;

      return isStable && isAtTarget ? stableFrames + 1 : 0;
    },

    scrollLeftWithoutAnimation(scrollContainer, targetLeft) {
      if (!scrollContainer) return;

      /*
       * CSS の scroll-snap / smooth scroll が効いたまま scrollLeft を書き換えるとアニメーションしてしまうため、
       * 一時的に 'auto' へ切り替えて瞬間移動させ、次フレームで元の scroll-behavior に戻す。
       */
      const previousScrollBehavior = scrollContainer.style.scrollBehavior;
      scrollContainer.style.scrollBehavior = 'auto';
      scrollContainer.scrollLeft = targetLeft;

      requestAnimationFrame(() => {
        scrollContainer.style.scrollBehavior = previousScrollBehavior;
      });
    },
  };

  namespace.ScrollUtils = ScrollUtils;
  window.AuremeProductGallery = namespace;
})();
